import { usePathname } from "next/navigation";

export default function usePageTypes() {
  const pathName = usePathname();  
  const isDetailsPage = pathName.startsWith("/for-sale/details/");
  const isSearchPage = !isDetailsPage && pathName.startsWith("/for-sale");
  return {
    hasSubNav: isDetailsPage || isSearchPage,
    isDetailsPage,
    isSearchPage,
  };
}
